// Packaging.Endpoint — either a Template or a Format.
//
// Per `.docs/v1/design/bounded-contexts.md` §3. Every registry entry
// carries a `source` endpoint and a `target` endpoint. The four edge
// categories (T→T / T→F / F→T / F→F) are derived from the pair, not
// stored — a `switch` on `(source.type, target.type)` covers them.
//
// Discriminant strings globally unique across BCs
// (`template_endpoint`, `format_endpoint`).
export { mkFormatEndpoint, mkTemplateEndpoint };
const mkTemplateEndpoint = (templateRef) => ({ type: "template_endpoint", templateRef });
const mkFormatEndpoint = (formatRef) => ({
    type: "format_endpoint",
    formatRef,
});
//# sourceMappingURL=endpoint.js.map